'use client';
import dynamic from 'next/dynamic';

const Timeline = dynamic(() =>
  import('@monoimin/organisms/blocks/timeline/Timeline').then(
    (mod) => mod.Timeline
  )
);

export { Timeline };
